import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Container from "../components/ui/Container/Container";
import { QueryKey } from "../services/query-keys";
import { IInfoWidget } from "../shared/IInfoWidget";
import ErrorsAlert from "../components/ErrorsAlert/ErrorsAlert";
import { ErrorResponse } from "../custom-fetch";
import Spinner from "../components/ui/Spinner/Spinner";
import InfoWidgetEdit from "../components/Admin/InfoWidgets/InfoWidgetEdit";
import { useInfoWidgetService } from "../services/info-widget-service";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { Route } from "../routes";

type Params = {
  id: string;
};

const InfoWidgetPage: React.FC = () => {
  const { id } = useParams<Params>();
  const { fetchInfoWidget } = useInfoWidgetService();

  const {
    data: widget,
    isLoading,
    isError,
    error,
  } = useQuery<IInfoWidget | undefined, ErrorResponse>({
    queryKey: [QueryKey.infoWidgets, id],
    queryFn: ({ signal }) => fetchInfoWidget(id!, { signal }),
    enabled: id !== 'add',
  });

  return (
    <>
      <PageHeading backTo={Route.infoWidgets}>{id === 'add' ? 'Add Widget' : 'Edit Widget'}</PageHeading>
      <Container>
        {isError && error ? (
          <ErrorsAlert errors={error.messages} />
        ) : isLoading && id !== 'add' ? (
          <Spinner />
        ) : (
          <InfoWidgetEdit id={id!} widget={widget} />
        )}
      </Container>
    </>
  );
};

export default InfoWidgetPage;
